import React from 'react';
import classNames from 'classnames';

import { IconCollection } from '..';

import css from './StarRatings.module.css';

const StarRatings = ({ rating = 0, max = 5, className }) => {
  const count = Math.max(0, Math.min(max, Math.floor(rating || 0)));

  return (
    <div className={classNames(css.starsRow, className)}>
      {Array.from({ length: count }).map((_, idx) => (
        <span key={idx} className={css.starIcon}>
          <IconCollection icon="star" />
        </span>
      ))}
    </div>
  );
};

export default StarRatings;
